<template>
  <v-card
    class="mb-3"
  >
    <v-form
      ref="formAnimal"
      v-model="validAnimal"
      lazy-validation
      @submit.prevent="calculosPasso1(animal)"
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          v-for="(input, name) in animal"
          :key="name"
          :class="input.tipo != TIPO_RADIOBUTTOM ? 'xs12 sm6 md4 lg3' : 'xs12'"
          :style="displayCondicional(input, animal)"
          pa-2
        >
          <div v-if="renderCondicional(input, animal)">
            <v-text-field
              v-money="input.precisao ? optionsNumber.float[idioma] : optionsNumber.int[idioma]"
              v-if="input.tipo === TIPO_NUMBER"
              :label="input.required ? input.title[idioma] + ' *' : input.title[idioma]"
              :rules="rulesAnimal(input, animal, idioma)"
              v-model.lazy="input.valor"
              class="input-form-animal"
              @change="calculo1(animal);"
            />
            <v-text-field
              v-money="input.precisao ? optionsNumber.float2[idioma] : optionsNumber.int[idioma]"
              v-if="input.tipo === TIPO_FLOAT2"
              :label="input.required ? input.title[idioma] + ' *' : input.title[idioma]"
              :rules="rulesAnimal(input, animal, idioma)"
              v-model.lazy="input.valor"
              class="input-form-animal"
              @change="calculo1(animal);"
            />
            <v-text-field
              v-money="input.precisao ? optionsNumber.porcentagemFloat[idioma] : optionsNumber.porcentagemInt[idioma]"
              v-if="input.tipo === TIPO_PORCENTAGEM"
              :label="input.title[idioma]"
              :rules="rulesAnimal(input, idioma)"
              v-model.lazy="input.valor"
              class="input-form-animal"
              @change="stepComplete[0] = false"
            />
            <v-text-field
              v-money="optionsNumber.money[idioma]"
              v-if="input.tipo === TIPO_MONEY"
              :label="input.title[idioma]"
              v-model.lazy="input.valor"
              class="input-form-animal"
              @change="calculo1(animal);"
            />
            <v-text-field
              v-if="input.tipo === TIPO_RESULTADO"
              :label="input.title[idioma]"
              v-model="input.valor"
              class="input-form-animal"
              readonly
            />
            <div v-else-if="input.tipo === TIPO_RADIOBUTTOM">
              <label
                v-if="input.title"
                class="label-radio"
              >
                {{ input.title[idioma] }}
              </label>
              <v-radio-group
                v-model="input.valor"
                v-bind="binding"
                :rules="[v => !!v || strings[idioma].obrigatorio]"
                :key="input.valor"
                @change="changeRadioAnimal(input, animal);stepComplete[0] = false;"

              >
                <v-radio
                  v-for="option in input.options"
                  :key="option.valor"
                  :label="option.title[idioma]"
                  :value="option.valor"
                  :style="displayRadioCondicional(input, option, animal)"

                  color="primary"
                />
              </v-radio-group>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout
      row
      wrap
      justify-end
    >
      <v-btn
        color="primary"
        @click="!stepComplete[0] ? calculosPasso1() : step = 2"
      >
        {{ strings[idioma].botao_seguinte }}
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </v-card>
</template>
<script>
import { mapState } from 'vuex'
import { VMoney } from 'v-money'
import { TIPO_NUMBER, TIPO_FLOAT2, TIPO_RADIOBUTTOM, TIPO_RESULTADO, TIPO_MONEY, TIPO_PORCENTAGEM, ID_LEITE_VACA, CRESCIMENTO_TERMINACAO, BEZERRO, VACA, FEMEA, MAX_PESO_MACHO, MAX_PESO_FEMEA, MAX_PESO_BEZERRO, MAX_GMD, MACHO, MACHO_CASTRADO } from '@/utils/types.js'
export default {
  directives: { money: VMoney },

  data: () => ({
    TIPO_NUMBER: TIPO_NUMBER,
    TIPO_RADIOBUTTOM: TIPO_RADIOBUTTOM,
    TIPO_RESULTADO: TIPO_RESULTADO,
    TIPO_MONEY: TIPO_MONEY,
    TIPO_PORCENTAGEM: TIPO_PORCENTAGEM,
    TIPO_FLOAT2: TIPO_FLOAT2,
    CRESCIMENTO_TERMINACAO: CRESCIMENTO_TERMINACAO,
    BEZERRO: BEZERRO,
    VACA: VACA,
    FEMEA: FEMEA,
    MACHO: MACHO,
    MACHO_CASTRADO: MACHO_CASTRADO,
    MAX_PESO_MACHO: MAX_PESO_MACHO,
    MAX_PESO_FEMEA: MAX_PESO_FEMEA,
    MAX_PESO_BEZERRO: MAX_PESO_BEZERRO,
    MAX_GMD: MAX_GMD,
    ID_LEITE_VACA: ID_LEITE_VACA,
    validAnimal: false

  }),
  computed: {
    ...mapState('app', ['animal', 'strings', 'idioma', 'optionsNumber', 'headersExigencias', 'exigencias', 'exigencias_selecionadas',
      'categorias_alimentos', 'alimentos_selecionados', 'ingredientes', 'composicao_racao', 'composicao_dieta', 'vc', 'fixavc', 'headersComposicaoRacao',
      'excrecao', 'headersExigenciasRelatorio', 'relatorio_financeiro', 'headersRelatorioFinanceiro']),
    binding () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndUp) binding.row = true
      else binding.row = false
      return binding
    },
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 289) + 'px'
    },
    heightOverflow () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 120) + 'px; overflow: auto;'
    }
  },
  methods: {
    calculo1 (animal) {
      this.stepComplete[0] = false
      if (this.idioma === 0) {
        animal['peso_corporal_medio'].valor = ((parseFloat(animal['peso_corporal_inicial'].valor.replace(/[.]/g, '').replace(/[,]/g, '.')) + parseFloat(animal['peso_corporal_final'].valor.replace(/[.]/g, '').replace(/[,]/g, '.'))) / 2.0).toFixed(2)
        animal['peso_corporal_medio'].valor = animal['peso_corporal_medio'].valor.replace(/[.]/g, ',')
        animal['custo_total'].valor = animal['custo_mao_de_obra'].valor ? (parseFloat(animal['custo_mao_de_obra'].valor.replace('R$', '').replace(/[.]/g, '').replace(/[,]/g, '.')) + parseFloat(animal['custo_energia'].valor.replace('R$', '').replace(/[.]/g, '').replace(/[,]/g, '.')) + parseFloat(animal['custo_maquinario'].valor.replace('R$', '').replace(/[.]/g, '').replace(/[,]/g, '.')) + parseFloat(animal['custo_medicamentos'].valor.replace('R$', '').replace(/[.]/g, '').replace(/[,]/g, '.')) + parseFloat(animal['custo_extra'].valor.replace('R$', '').replace(/[.]/g, '').replace(/[,]/g, '.'))).toFixed(2) : null
        animal['custo_total'].valor = animal['custo_total'].valor ? 'R$' + animal['custo_total'].valor.replace(/[.]/g, ',') : null
      } else {
        animal['peso_corporal_medio'].valor = ((parseFloat(animal['peso_corporal_inicial'].valor.replace(/[,]/g, '')) + parseFloat(animal['peso_corporal_final'].valor.replace(/[,]/g, ''))) / 2.0).toFixed(2)
        animal['custo_total'].valor = animal['custo_mao_de_obra'].valor ? (parseFloat(animal['custo_mao_de_obra'].valor.replace('U$', '').replace(/[,]/g, '')) + parseFloat(animal['custo_energia'].valor.replace('U$', '').replace(/[,]/g, '')) + parseFloat(animal['custo_maquinario'].valor.replace('U$', '').replace(/[,]/g, '')) + parseFloat(animal['custo_medicamentos'].valor.replace('U$', '').replace(/[,]/g, '')) + parseFloat(animal['custo_extra'].valor.replace('U$', '').replace(/[,]/g, ''))).toFixed(2) : null
        animal['custo_total'].valor = animal['custo_total'].valor ? 'U$' + animal['custo_total'].valor : null
      }
    },
    calculosPasso1 () {
      if (this.$refs.formAnimal.validate()) {
        this.step = 2
        this.loadingStep2 = true
        this.$nextTick(() => {
          setTimeout(() => {
            this.$store.commit('setLeiteDeVaca')
            this.$store.dispatch('calculaExigencias').then(() => {
              this.stepComplete[0] = true
              this.loadingStep2 = false
            })
          }, 1000)
        })
      }
    },
    displayCondicional (input, animal) {
      if (!input.depende) return null
      for (var i = 0; i < input.depende.length; i++) {
        if (input.valorDepende[i].includes(animal[input.depende[i]].valor) && this.renderCondicional(animal[input.depende[i]], animal)) return null
      }
      return 'display: none'
    },
    displayRadioCondicional (input, option, animal) {
      if (!option.depende) return null
      if ((option.valorDepende.includes(animal[option.depende].valor) || !animal[option.depende].valor) && this.renderCondicional(animal[option.depende], animal)) return null
      if (input.valor === option.valor) input.valor = null
      return 'display: none'
    },
    renderCondicional (input, animal) {
      if (!input.depende) return true
      for (var i = 0; i < input.depende.length; i++) {
        if (input.valorDepende[i].includes(animal[input.depende[i]].valor) && this.renderCondicional(animal[input.depende[i]], animal)) return true
      }
      return false
    },
    changeRadioAnimal (input, animal) {
      let val = input.valor
      if (val === CRESCIMENTO_TERMINACAO || val === VACA || val === BEZERRO) {
        this.$nextTick(() => {
          this.$refs.formAnimal.validate()
        })
      }
    },
    rulesAnimal (input, animal, idioma) {
      var rule = []
      if (idioma === undefined) idioma = this.idioma

      if (!input.required) {
        if (idioma === 0) {
          if ((input.minDepende !== undefined) && input.valor) {
            input.minDepende.forEach((dependencia) => {
              if (animal[dependencia]) {
                let input2 = animal[dependencia]
                rule.push(v => parseFloat(v.replace(/[.]/g, '').replace(/[,]/g, '.')) > parseFloat(input2.valor.replace(/[.]/g, '').replace(/[,]/g, '.')) || 'Valor deve ser maior que ' + String(input.max).replace(/[.]/g, ','))
              }
            })
          }
          if ((input.maxDepende !== undefined) && input.valor) {
            input.maxDepende.forEach((dependencia) => {
              if (animal[dependencia]) {
                let input2 = animal[dependencia]
                rule.push(v => parseFloat(input2.valor.replace(/[.]/g, '').replace(/[,]/g, '.')) === 0 || parseFloat(v.replace(/[.]/g, '').replace(/[,]/g, '.')) < parseFloat(input2.valor.replace(/[.]/g, '').replace(/[,]/g, '.')) || 'Valor deve ser menor que ' + input2.title[idioma])
              }
            })
          }
          if (input.max !== undefined && input.valor) { rule.push(v => parseFloat(v.replace(/[.]/g, '').replace(/[,]/g, '.')) <= input.max || 'Valor deve ser menor que ' + String(input.max).replace(/[.]/g, ',')) }
          if (input.min !== undefined && input.valor) {
            rule.push(v => parseFloat(v.replace(/[.]/g, '').replace(/[,]/g, '.')) >= input.min || 'Valor deve ser maior que ' + String(input.min).replace(/[.]/g, ','))
          }
        } else if (idioma === 1) {
          if ((input.minDepende !== undefined) && input.valor) {
            input.minDepende.forEach((dependencia) => {
              if (animal[dependencia]) {
                let input2 = animal[dependencia]
                rule.push(v => parseFloat(v.replace(/[.]/g, '').replace(/[,]/g, '.')) > parseFloat(input2.valor.replace(/[.]/g, '').replace(/[,]/g, '.')) || 'Value must be higher than ' + String(input.max).replace(/[.]/g, ','))
              }
            })
          }
          if ((input.maxDepende !== undefined) && input.valor) {
            input.maxDepende.forEach((dependencia) => {
              if (animal[dependencia]) {
                let input2 = animal[dependencia]
                rule.push(v => parseFloat(input2.valor.replace(/[.]/g, '').replace(/[,]/g, '.')) === 0 || parseFloat(v.replace(/[.]/g, '').replace(/[,]/g, '.')) < parseFloat(input2.valor.replace(/[.]/g, '').replace(/[,]/g, '.')) || 'Value must be less than ' + input2.title[idioma])
              }
            })
          }
          if (input.max !== undefined && input.valor) { rule.push(v => parseFloat(v.replace(/[,]/g, '')) <= input.max || 'Value must be less than ' + String(input.max).replace(/[.]/g, ',')) }
          if (input.min !== undefined && input.valor) { rule.push(v => parseFloat(v.replace(/[,]/g, '')) >= input.min || 'Value must be higher than ' + String(input.min).replace(/[.]/g, ',')) }
        }
      } else {
        if (idioma === 0) {
          if ((input.minDepende !== undefined) && input.valor) {
            input.minDepende.forEach((dependencia) => {
              if (animal[dependencia]) {
                let input2 = animal[dependencia]
                rule.push(v => parseFloat(v.replace(/[.]/g, '').replace(/[,]/g, '.')) > parseFloat(input2.valor.replace(/[.]/g, '').replace(/[,]/g, '.')) || 'Valor deve ser maior que ' + input2.title[idioma])
              }
            })
          }
          if ((input.maxDepende !== undefined) && input.valor) {
            input.maxDepende.forEach((dependencia) => {
              if (animal[dependencia]) {
                let input2 = animal[dependencia]
                rule.push(v => parseFloat(input2.valor.replace(/[.]/g, '').replace(/[,]/g, '.')) === 0 || parseFloat(v.replace(/[.]/g, '').replace(/[,]/g, '.')) < parseFloat(input2.valor.replace(/[.]/g, '').replace(/[,]/g, '.')) || 'Valor deve ser menor que ' + input2.title[idioma])
              }
            })
          }
          if (input.max !== undefined && input.valor) { rule.push(v => parseFloat(v.replace(/[.]/g, '').replace(/[,]/g, '.')) <= input.max || 'Valor deve ser menor que ' + String(input.max).replace(/[.]/g, ',')) }
          if (input.min !== undefined && input.valor) {
            rule.push(v => parseFloat(v.replace(/[.]/g, '').replace(/[,]/g, '.')) >= input.min || 'Valor deve ser maior que ' + String(input.min).replace(/[.]/g, ','))
          }
        } else if (idioma === 1) {
          if ((input.minDepende !== undefined) && input.valor) {
            input.minDepende.forEach((dependencia) => {
              if (animal[dependencia]) {
                let input2 = animal[dependencia]
                rule.push(v => parseFloat(v.replace(/[.]/g, '').replace(/[,]/g, '')) >= parseFloat(input2.valor.replace(/[,]/g, '')) || 'Value must be higher than ' + input2.title[idioma])
              }
            })
          }
          if ((input.maxDepende !== undefined) && input.valor) {
            input.maxDepende.forEach((dependencia) => {
              if (animal[dependencia]) {
                let input2 = animal[dependencia]
                rule.push(v => parseFloat(input2.valor.replace(/[,]/g, '')) === 0 || parseFloat(v.replace(/[.]/g, '').replace(/[,]/g, '.')) <= parseFloat(input2.valor.replace(/[,]/g, '')) || 'Value must be less than ' + input2.title[idioma])
              }
            })
          }
          if (input.max !== undefined && input.valor) { rule.push(v => parseFloat(v.replace(/[,]/g, '')) <= input.max || 'Value must be less than ' + String(input.max).replace(/[.]/g, ',')) }
          if (input.min !== undefined && input.valor) { rule.push(v => parseFloat(v.replace(/[,]/g, '')) >= input.min || 'Value must be higher than ' + String(input.min).replace(/[.]/g, ',')) }
        }
        if (idioma === 0 && input.precisao) {
          if (input.max && input.valor) {
            rule.push(v => parseFloat(v.replace(/[.]/g, '').replace(/[,]/g, '.')) <= input.max || 'Valor deve ser menor que ' + String(input.max).replace(/[.]/g, ','))
          }
          if (input.min !== undefined && input.valor) { rule.push(v => parseFloat(v.replace(/[,]/g, '')) >= input.min || 'Valor deve ser maior que ' + String(input.min).replace(/[.]/g, ',')) }
          rule.push(v => v !== '0,0' || this.strings[this.idioma].obrigatorio)
          rule.push(v => v !== '0,00' || this.strings[this.idioma].obrigatorio)
        } else if (idioma === 1 && input.precisao) {
          if (input.max && input.valor) {
            rule.push(v => parseFloat(v.replace(/[,]/g, '')) <= input.max || 'Value must be less than ' + String(input.max))
          }
          if (input.min !== undefined && input.valor) { rule.push(v => parseFloat(v.replace(/[,]/g, '')) >= input.min || 'Value must be higher than ' + String(input.min).replace(/[.]/g, ',')) }
          rule.push(v => v !== '0.0' || this.strings[this.idioma].obrigatorio)
          rule.push(v => v !== '0.00' || this.strings[this.idioma].obrigatorio)
        } else if (!input.precisao) {
          rule.push(v => v !== '0' || this.strings[this.idioma].obrigatorio)
        }
        if (input.maxPeso && input.valor && idioma === 0) {
          if (animal.tipo.valor === this.BEZERRO) {
            rule.push(v => parseFloat(v.replace(/[.]/g, '').replace(/[,]/g, '.')) <= this.MAX_PESO_BEZERRO || 'Valor deve ser menor que ' + String(this.MAX_PESO_BEZERRO).replace(/[.]/g, ','))
          } else if (animal.tipo.valor === this.VACA || (animal.tipo.valor === this.CRESCIMENTO_TERMINACAO && animal.sexo.valor === this.FEMEA)) {
            rule.push(v => parseFloat(v.replace(/[.]/g, '').replace(/[,]/g, '.')) <= this.MAX_PESO_FEMEA || 'Valor deve ser menor que ' + String(this.MAX_PESO_FEMEA).replace(/[.]/g, ','))
          } else if (animal.tipo.valor === this.CRESCIMENTO_TERMINACAO && (animal.sexo.valor === this.MACHO || animal.sexo.valor === this.MACHO_CASTRADO)) {
            rule.push(v => parseFloat(v.replace(/[.]/g, '').replace(/[,]/g, '.')) <= this.MAX_PESO_MACHO || 'Valor deve ser menor que ' + String(this.MAX_PESO_MACHO).replace(/[.]/g, ','))
          } else if (animal.tipo.valor === this.CRESCIMENTO_TERMINACAO) {
            rule.push(v => parseFloat(v.replace(/[.]/g, '').replace(/[,]/g, '.')) <= this.MAX_PESO_MACHO || 'Valor deve ser menor que ' + String(this.MAX_PESO_MACHO).replace(/[.]/g, ','))
          }
        } else if (input.maxPeso && input.valor && idioma === 1) {
          if (animal.tipo.valor === this.BEZERRO) {
            rule.push(v => parseFloat(v.replace(/[,]/g, '')) <= this.MAX_PESO_BEZERRO || 'Value must be less than ' + String(this.MAX_PESO_BEZERRO))
          } else if (animal.tipo.valor === this.VACA || (animal.tipo.valor === this.CRESCIMENTO_TERMINACAO && animal.sexo.valor === this.FEMEA)) {
            rule.push(v => parseFloat(v.replace(/[,]/g, '')) <= this.MAX_PESO_FEMEA || 'Value must be less than ' + String(this.MAX_PESO_FEMEA))
          } else if (animal.tipo.valor === this.CRESCIMENTO_TERMINACAO && (animal.sexo.valor === this.MACHO || animal.sexo.valor === this.MACHO_CASTRADO)) {
            rule.push(v => parseFloat(v.replace(/[,]/g, '')) <= this.MAX_PESO_MACHO || 'Value must be less than ' + String(this.MAX_PESO_MACHO))
          } else if (animal.tipo.valor === this.CRESCIMENTO_TERMINACAO) {
            rule.push(v => parseFloat(v.replace(/[,]/g, '.')) <= this.MAX_PESO_MACHO || 'Valor deve ser menor que ' + String(this.MAX_PESO_MACHO).replace(/[.]/g, ','))
          }
        }
      }
      return rule
    }
  }

}
</script>
